export const SALUTATIONS = [
  { value: '', label: '' },
  { value: 'mr', label: 'Mr.' },
  { value: 'mrs', label: 'Mrs.' },
  { value: 'ms', label: 'Ms.' },
  { value: 'miss', label: 'Miss' },
  { value: 'dr', label: 'Dr.' },
];

export const GENDER_OPTIONS = [
  { value: '', label: '' },
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'x', label: 'X' },
];
